import { useEffect, useState } from "react";
import { useDisclosure } from "@mantine/hooks";
import { Burger, Drawer, HoverCard } from "@mantine/core";
import { useNavigate, useLocation } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const actualSessionsBookingUrl =
    process.env.REACT_APP_ACTUAL_SESSIONS_BOOKING_URL ||
    "https://www.bookable.page/aleksandra";
  const [scrolled, setScrolled] = useState(false);
  const [opened, { toggle, close }] = useDisclosure();
  const [consultationsMobileOpen, setConsultationsMobileOpen] = useState(false);

  const handleHomeClick = () => {
    if (location.pathname === "/") {
      // Already on home page, scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Navigate to home
      navigate("/");
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div className="sticky top-0 z-50 w-full text-primary font-bold flex justify-between items-center gap-4 px-4 lg:px-6 xl:px-10 text-lg bg-[#F8F9FA] min-h-[84px] h-[84px] ">
        <div
          className={`flex h-[84px]
              lg:hidden justify-start items-center
               transition-all duration-300`}
        >
          <a href="/">
            {/* <img src="/OriginalLogoSymbol.png" alt="logo" className="h-[40%] w-[40%]"/> */}
            <img
              src="/TransparentLogo.svg"
              alt="logo"
              className="h-36 w-auto"
            />
          </a>
        </div>
        <div
          className={`lg:flex hidden flex-1 min-w-0 ${
            scrolled
              ? "justify-center items-center"
              : "justify-center items-center"
          } transition-all duration-300 gap-6 xl:gap-10 text-base xl:text-lg`}
        >
          <p
            onClick={() => navigate("/about")}
            className="cursor-pointer hover:opacity-70 transition whitespace-nowrap"
          >
            About
          </p>
          <p
            onClick={() => navigate("/approach")}
            className="cursor-pointer hover:opacity-70 transition whitespace-nowrap"
          >
            Approach
          </p>
          <div
            className={`flex 
               lg:justify-center lg:items-center justify-start items-center
              transition-all duration-300 lg:w-[180px] xl:w-[220px] lg:flex-none`}
          >
            <a href="/">
              <img
                src="/Transparent Logonrwa.png"
                alt="logo"
                className="w-full h-auto max-w-none"
              />
            </a>
          </div>
          {/* )} */}
          {/* Consultations Hover Card */}
          <HoverCard width={220} shadow="md" openDelay={80} closeDelay={120}>
            <HoverCard.Target>
              <p className="cursor-pointer hover:opacity-70 transition flex items-center gap-2 whitespace-nowrap">
                Consultations
                <svg
                  className="w-4 h-4 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 14l-7 7m0 0l-7-7m7 7V3"
                  />
                </svg>
              </p>
            </HoverCard.Target>
            <HoverCard.Dropdown className="p-0 overflow-hidden border border-gray-200">
              <button
                onClick={() => navigate("/nutrition-therapy")}
                className="w-full px-4 py-3 text-left hover:bg-gradient-to-r hover:from-[#245940] hover:to-[#1f4830] hover:text-white text-gray-700 transition-all duration-200 flex items-center gap-3 group"
              >
                <span className="text-lg">🌿</span>
                <div>
                  <p className="font-semibold text-sm">Nutrition Therapy</p>
                  <p className="text-xs opacity-70 group-hover:opacity-100">
                    Personalised plans
                  </p>
                </div>
              </button>
              <div className="border-t border-gray-100"></div>
              <button
                onClick={() => navigate("/consultations")}
                className="w-full px-4 py-3 text-left hover:bg-gradient-to-r hover:from-[#245940] hover:to-[#1f4830] hover:text-white text-gray-700 transition-all duration-200 flex items-center gap-3 group"
              >
                <span className="text-lg">💬</span>
                <div>
                  <p className="font-semibold text-sm">Pricing</p>
                  <p className="text-xs opacity-70 group-hover:opacity-100">
                    Book a session
                  </p>
                </div>
              </button>
            </HoverCard.Dropdown>
          </HoverCard>
          <p
            onClick={() => navigate("/contact")}
            className="cursor-pointer hover:opacity-70 transition whitespace-nowrap"
          >
            Contact
          </p>
        </div>
        <div className="hidden lg:flex items-center gap-3 xl:gap-5 flex-none">
          <button
            type="button"
            onClick={handleHomeClick}
            className="p-2 rounded-md hover:bg-gray-100 transition"
            aria-label="Go to home"
          >
            <svg
              className="w-5 h-5 text-primary"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 10.5l9-7 9 7M5 10v9a1 1 0 001 1h4v-6h4v6h4a1 1 0 001-1v-9"
              />
            </svg>
          </button>
          <button
            onClick={() =>
              window.open(
                actualSessionsBookingUrl,
                "_blank",
                "noopener,noreferrer",
              )
            }
            className="bg-primary hidden lg:block text-white px-3 xl:px-4 text-xs xl:text-sm py-2 rounded-md hover:bg-[#245940] transition duration-300 whitespace-nowrap"
          >
            Book Consultations
          </button>
        </div>
        <div className="lg:hidden  flex items-center space-x-4">
          <button
            type="button"
            onClick={handleHomeClick}
            className="p-2 rounded-md hover:bg-gray-100 transition"
            aria-label="Go to home"
          >
            <svg
              className="w-5 h-5 text-primary"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 10.5l9-7 9 7M5 10v9a1 1 0 001 1h4v-6h4v6h4a1 1 0 001-1v-9"
              />
            </svg>
          </button>
          <button
            className="bg-primary text-white p-3 rounded-md text-xs hover:bg-[#245940] transition duration-300 whitespace-nowrap"
            onClick={() =>
              window.open(
                actualSessionsBookingUrl,
                "_blank",
                "noopener,noreferrer",
              )
            }
          >
            Book now
          </button>
          <Burger
            opened={opened}
            onClick={toggle}
            aria-label="Toggle navigation"
          />
        </div>
        <Drawer opened={opened} position="bottom" onClose={toggle} size="50%">
          {" "}
          {/* //animate-slide-up-fade */}
          <div className="fixed inset-0 top-10 w-full h-screen bg-[#F8F9FA] z-40 flex flex-col items-start p-10   lg:hidden text-xl ">
            <p
              onClick={() => {
                navigate("/about");
                close();
              }}
              className="cursor-pointer text-primary font-bold"
            >
              About
            </p>
            <p
              onClick={() => {
                navigate("/approach");
                close();
              }}
              className="cursor-pointer text-primary font-bold"
            >
              Approach
            </p>
            {/* Mobile Consultations Dropdown */}
            <div>
              <button
                onClick={() =>
                  setConsultationsMobileOpen(!consultationsMobileOpen)
                }
                className="w-full text-left cursor-pointer text-primary font-bold flex items-center justify-between"
              >
                Consultations
                <svg
                  className={`w-5 h-5 transition-transform duration-300 ${
                    consultationsMobileOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* Mobile Dropdown Items */}
              {consultationsMobileOpen && (
                <div className="mt-3 ml-4 space-y-3 border-l-2 border-[#245940] pl-4">
                  <button
                    onClick={() => {
                      navigate("/nutrition-therapy");
                      setConsultationsMobileOpen(false);
                      close();
                    }}
                    className="w-full text-left cursor-pointer text-primary font-semibold text-sm hover:opacity-70 transition flex items-center gap-2"
                  >
                    <span>🌿</span>
                    Nutrition Therapy
                  </button>
                  <button
                    onClick={() => {
                      navigate("/consultations");
                      setConsultationsMobileOpen(false);
                      close();
                    }}
                    className="w-full text-left cursor-pointer text-primary font-semibold text-sm hover:opacity-70 transition flex items-center gap-2"
                  >
                    <span>💬</span>
                    Pricing
                  </button>
                </div>
              )}
            </div>
            <p
              onClick={() => {
                navigate("/contact");
                close();
              }}
              className="cursor-pointer text-primary font-bold"
            >
              Contact
            </p>
          </div>
        </Drawer>

        {/* )} */}
      </div>
    </>
  );
}
